import { memo } from "react";
import { FaLock, FaUnlock } from "react-icons/fa";

interface ActionButtonsProps {
  onOpenAll: () => void;
  onCloseAll: () => void;
}

const ActionButtons = memo<ActionButtonsProps>(({ onOpenAll, onCloseAll }) => (
  <div className="flex border border-white/[0.08] rounded-md overflow-hidden bg-white/[0.03]">
    <button
      onClick={onOpenAll}
      className="flex-1 py-2.5 flex items-center justify-center gap-2 text-white/65 hover:text-white text-[14px] hover:bg-white/[0.04] transition-colors"
    >
      <FaUnlock size={13} className="flex-shrink-0" />
      <span>Open all Doors</span>
    </button>

    <div className="w-px bg-white/[0.08]" />

    <button
      onClick={onCloseAll}
      className="flex-1 py-2.5 flex items-center justify-center gap-2 text-[#FF1F1F] hover:text-[#FF1F1F]/70 text-[14px] hover:bg-red-500/[0.06] transition-colors"
    >
      <FaLock size={13} className="flex-shrink-0" />
      <span>Close All Doors</span>
    </button>
  </div>
));

ActionButtons.displayName = "ActionButtons";
export default ActionButtons;
